import React from "react";
import {
  Route,
  Switch
} from "react-router-dom";
import Home from "../pages/Home";
import StartProject from "../pages/StartProject";
import Prestations from "../pages/Prestations";
import News from "../pages/News";
import PrestationDetails from "../pages/PrestationDetails";
import Contact from "../pages/Contact";
import Company from "../pages/Company";
import History from "../pages/History";


const RoutePath = () => {
  return (
    <Switch>
      <Route exact path="/" component={Home} />
      <Route path="/newproject" component={StartProject} />
      <Route exact path="/news" component={News} />
      <Route exact path="/prestations" component={Prestations} />
      <Route exact path="/prestations/:id-:prestation" component={PrestationDetails} />
      <Route path="/history" component={History} />
      <Route path="/company" component={Company} />
      <Route exact path="/contact" component={Contact} />
      <Route exact path="/mentions" component={Home} />
    </Switch>
  )
};

export default RoutePath;